import { useSellarUser } from "../hooks/useSellarUser.shared";

export function useBuildStripeDashboardUrl() {
  const { user } = useSellarUser();
  const isAdmin = user?.type === "admin";

  return (params: {
    type: "invoice" | "payment";
    stripeAccountId: string;
    id: string;
  }): string => {
    const testPrefix =
      import.meta.env.VITE_ENV === "development" ? "test/" : "";
    const path = params.type === "invoice" ? "invoices" : "payments";
    const resourcePath = `${path}/${params.id}`;

    if (isAdmin) {
      console.log({ isAdmin });
      const platformAccountId = import.meta.env.VITE_STRIPE_PLATFORM_ACCOUNT_ID;
      if (platformAccountId) {
        console.log({ accountIdExists: true });
        return `https://dashboard.stripe.com/${platformAccountId}/connect/accounts/${params.stripeAccountId}/${testPrefix}${resourcePath}`;
      }
    }

    return `https://dashboard.stripe.com/${params.stripeAccountId}/${testPrefix}${resourcePath}`;
  };
}
